/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from 'ethers'
import { Provider, TransactionRequest } from '@ethersproject/providers'
import { Contract, ContractFactory, Overrides } from '@ethersproject/contracts'

import type { ERC1155 } from '../ERC1155'

export class ERC1155__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer)
  }

  deploy(uri_: string, overrides?: Overrides): Promise<ERC1155> {
    return super.deploy(uri_, overrides || {}) as Promise<ERC1155>
  }
  getDeployTransaction(
    uri_: string,
    overrides?: Overrides
  ): TransactionRequest {
    return super.getDeployTransaction(uri_, overrides || {})
  }
  attach(address: string): ERC1155 {
    return super.attach(address) as ERC1155
  }
  connect(signer: Signer): ERC1155__factory {
    return super.connect(signer) as ERC1155__factory
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC1155 {
    return new Contract(address, _abi, signerOrProvider) as ERC1155
  }
}

const _abi = [
  {
    inputs: [
      {
        internalType: 'string',
        name: 'uri_',
        type: 'string'
      }
    ],
    stateMutability: 'nonpayable',
    type: 'constructor'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'ApprovalForAll',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        indexed: false,
        internalType: 'uint256[]',
        name: 'values',
        type: 'uint256[]'
      }
    ],
    name: 'TransferBatch',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        indexed: true,
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        indexed: false,
        internalType: 'uint256',
        name: 'value',
        type: 'uint256'
      }
    ],
    name: 'TransferSingle',
    type: 'event'
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: 'string',
        name: 'value',
        type: 'string'
      },
      {
        indexed: true,
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      }
    ],
    name: 'URI',
    type: 'event'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      }
    ],
    name: 'balanceOf',
    outputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address[]',
        name: 'accounts',
        type: 'address[]'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      }
    ],
    name: 'balanceOfBatch',
    outputs: [
      {
        internalType: 'uint256[]',
        name: '',
        type: 'uint256[]'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'account',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      }
    ],
    name: 'isApprovedForAll',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256[]',
        name: 'ids',
        type: 'uint256[]'
      },
      {
        internalType: 'uint256[]',
        name: 'amounts',
        type: 'uint256[]'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'safeBatchTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'from',
        type: 'address'
      },
      {
        internalType: 'address',
        name: 'to',
        type: 'address'
      },
      {
        internalType: 'uint256',
        name: 'id',
        type: 'uint256'
      },
      {
        internalType: 'uint256',
        name: 'amount',
        type: 'uint256'
      },
      {
        internalType: 'bytes',
        name: 'data',
        type: 'bytes'
      }
    ],
    name: 'safeTransferFrom',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'address',
        name: 'operator',
        type: 'address'
      },
      {
        internalType: 'bool',
        name: 'approved',
        type: 'bool'
      }
    ],
    name: 'setApprovalForAll',
    outputs: [],
    stateMutability: 'nonpayable',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'bytes4',
        name: 'interfaceId',
        type: 'bytes4'
      }
    ],
    name: 'supportsInterface',
    outputs: [
      {
        internalType: 'bool',
        name: '',
        type: 'bool'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  },
  {
    inputs: [
      {
        internalType: 'uint256',
        name: '',
        type: 'uint256'
      }
    ],
    name: 'uri',
    outputs: [
      {
        internalType: 'string',
        name: '',
        type: 'string'
      }
    ],
    stateMutability: 'view',
    type: 'function'
  }
]

const _bytecode =
  '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'
